import React, { Component } from "react"
import { Link } from "react-router-dom"
import "./Helpers"
import cn from "classnames"
import "./SheetMenu.css"
 
export default class SheetMenu extends Component {  
	constructor(props) {
		super(props)
		const selectedSheetID = props.selectedSheetID
		const ProductName = props.ProductName
		const FullProductPath = props.FullProductPath
		const datasetDetails = props.datasetDetails
		const FieldArray = props.FieldArray
		const DetailFields = props.DetailFields
		const TitleViewField = props.TitleViewField
		const appURL = props.appURL

		this.state = {
			ViewObjectFeatured: {},
			ViewObjectNormal: {},
			datasetDetails: datasetDetails,
			TitleViewField: TitleViewField,
			VPDatasetID: "",
			FieldArray: FieldArray,
			DetailFields: DetailFields,
			datasetID: props.datasetID,
			ProductName: ProductName,
			FullProductPath: FullProductPath,
			loading: true,
			selectedSheetID: selectedSheetID,
			appURL: appURL
		}  
	}
	fetchData(datasetID, sheetData){
		let FeaturedSheets = []
		let NormalSheets = []
		let VPDatasetID = ""
		for (var dataset in sheetData){
			var sheetNames = JSON.parse(sheetData[dataset].SheetName)
			VPDatasetID = sheetData[dataset].ID[0]
		}
		var sortable = []
		for (var sheet in sheetNames){
			sortable.push([sheet, sheetNames[sheet]])
		}

		sortable.sort(function(a, b) {
			return a[1].screenshot[0] - b[1].screenshot[0]
		})
		
		var index = 0
		for (var temp in sheetNames){
			let sheet = sortable[index][0]
			var sheetType = sheetNames[sheet].status.toString()
			var sheetName = sheetNames[sheet].Name.toString()
			if (sheetType === "featured"){
				FeaturedSheets.push(sheetNames[sheet])
			}
			else if ((sheetType === "normal" || sheetType === "") && sheetName !== "Summary"){
				NormalSheets.push(sheetNames[sheet])
			}
			index++
		}
		this.setState({
			ViewObjectFeatured: FeaturedSheets,
			ViewObjectNormal: NormalSheets,
			VPDatasetID: VPDatasetID,
			loading: false
		})
	}
	componentDidMount(){
		this.fetchData(this.state.datasetID, this.state.datasetDetails)
	}
	// eslint-disable-next-line no-unused-vars
	componentDidUpdate(prevProps, prevState){
		if (prevProps.selectedSheetID !== this.props.selectedSheetID){
			this.setState({
				selectedSheetID: this.props.selectedSheetID
			})
		}
	}

	render() {
 
		const datasetID = this.state.datasetID
		const selectedSheetID = this.state.selectedSheetID
		const ProductName = this.state.ProductName
		const TitleViewField = this.state.TitleViewField
		const FieldArray = this.state.FieldArray
		const DetailFields = this.state.DetailFields
		const appURL = this.state.appURL
		const VPDatasetID = this.state.VPDatasetID
		let classNames = cn("SheetMenuBlock")
		if (selectedSheetID === undefined || selectedSheetID === "" || selectedSheetID === "Home") {
			classNames = cn("SheetMenuBlock selected")
		}
 
		return (
			<div id="SheetMenu" onClick={this.props.handleOnClick} >
				<Link className="SheetMenuLink" to={{pathname: "/" + ProductName + "/" + "Dashboard/" + datasetID, state:{VPDatasetID: VPDatasetID, appURL: appURL, Note: ""}}} key="Home"><div className={classNames} id="Home"><span className="vp-icon-Home"></span>Home</div></Link>
				{/*
				Object.values(this.state.ViewObject).slice(-1).map(function (value) {
					var content = "";
					var params = {
						pathname: '/summary/' + datasetID,
						ViewNote: value.Note[0]
					}
					classNames = cn("SheetMenuBlock")
					if (selectedSheetID === value.ID[0]){
						classNames = cn("SheetMenuBlock selected")
					}
					if (value.Note[0] !== ""){
						content = <Link className="SheetMenuLink" to={params} key={value.ID}><div className={classNames} id={value.ID}><span className="Note" title={value.Note[0]}><img alt="note" src={window.location.origin + '/note.png'}/></span>Summary</div></Link>;
					} else {
						content = <Link className="SheetMenuLink" to={params} key={value.ID}><div className={classNames} id={value.ID}><span className="NoNote"></span>Summary</div></Link>;
					}
					return content;
				})
			*/}
				{
					Object.values(this.state.ViewObjectFeatured).map(function (value) {
						let iconString = ""
						if (value.hasOwnProperty("BrowserType")) {
							iconString = cn("vp-icon-16 WebIcon " + value.BrowserType[0])
						}
						else {
							iconString = cn("vp-icon-16 WebIcon " + value.Type[0])
						}
						let content = ""
						let detail1 = []
						let detail2 = []
						if (value.detailviews[0] !== ""){
							detail1 = JSON.parse(value.detailviews[0])
						}
						if (value.detailviewsuser[0] !== ""){
							detail2 = Object.values(JSON.parse(value.detailviewsuser[0]))
						}
						let DetailViewsArray = detail2
						if (typeof(detail1) === 'object'){
							if (Object.keys(detail1).length > 0){
								if (detail1.hasOwnProperty('UseDefault')){
									if (detail1.UseDefault === 0){
										DetailViewsArray = detail1.DetailFields
									}
								}
							}
						}
						//get first 3 detail views (0, 3 (non-inclusive))
						//DetailViewsArray = DetailViewsArray.filter(Boolean).slice(0,3)
						classNames = cn("SheetMenuBlock")
						if (selectedSheetID === value.ID[0]){
							classNames = cn("SheetMenuBlock selected")
						}
						if (value.status[0] !== "hidden"){
							if (value.Note[0] !== ""){
								switch (String(value.Type)) {
								case "List":
									content = <Link className="SheetMenuLink" to={{pathname: "/" + ProductName + "/" + "list/" + datasetID + "/" + value.ID, state:  {VPDatasetID: VPDatasetID, appURL: appURL, ViewNote: value.Note[0], DetailViews: DetailViewsArray, FieldArray: FieldArray, DetailFields: DetailFields, TitleViewField: TitleViewField}}} key={value.ID}><div className={classNames} id={value.ID}><span className={iconString}></span><span className="SheetMenuText">{value.Name}</span><span className="Note" title={value.Note[0]}><div className='vp-icon-16 vp-icon-note'></div></span></div></Link>
									break
								case "Matrix":
									content = <Link className="SheetMenuLink" to={{pathname: "/" + ProductName + "/" + "matrix/" + datasetID + "/" + value.ID, state:  {VPDatasetID: VPDatasetID, appURL: appURL, ViewNote: value.Note[0], DetailViews: DetailViewsArray, FieldArray: FieldArray, DetailFields: DetailFields, TitleViewField: TitleViewField}}} key={value.ID}><div className={classNames} id={value.ID}><span className={iconString}></span><span className="SheetMenuText">{value.Name}</span><span className="Note" title={value.Note[0]}><div className='vp-icon-16 vp-icon-note'></div></span></div></Link>
									break
								case "Browser":
									
									if (String(value.Name) !== "Summary") {
										content = <Link className="SheetMenuLink" to={{pathname: "/" + ProductName + "/" + "browser/" + datasetID + "/" + value.ID, state:  {VPDatasetID: VPDatasetID, appURL: appURL, ViewNote: value.Note[0], DetailViews: DetailViewsArray, FieldArray: FieldArray, DetailFields: DetailFields, TitleViewField: TitleViewField}}} key={value.ID}><div className={classNames} id={value.ID}><span className={iconString}></span><span className="SheetMenuText">{value.Name}</span><span className="Note" title={value.Note[0]}><div className='vp-icon-16 vp-icon-note'></div></span></div></Link>
									}
									break
								default:
									content = ""
									break
								}
							} else {
								switch (String(value.Type)) {
								case "List":
									
									content = <Link className="SheetMenuLink" to={{pathname: "/" + ProductName + "/" + "list/" + datasetID + "/" + value.ID, state:  {VPDatasetID: VPDatasetID, appURL: appURL, ViewNote: value.Note[0], DetailViews: DetailViewsArray, FieldArray: FieldArray, DetailFields: DetailFields, TitleViewField: TitleViewField}}} key={value.ID}><div className={classNames} id={value.ID}><span className={iconString}></span><span className="SheetMenuText">{value.Name}</span><span className="NoNote"></span></div></Link>
									break
								case "Matrix":
									
									content = <Link className="SheetMenuLink" to={{pathname: "/" + ProductName + "/" + "matrix/" + datasetID + "/" + value.ID, state:  {VPDatasetID: VPDatasetID, appURL: appURL, ViewNote: value.Note[0], DetailViews: DetailViewsArray, FieldArray: FieldArray, DetailFields: DetailFields, TitleViewField: TitleViewField}}} key={value.ID}><div className={classNames} id={value.ID}><span className={iconString}></span><span className="SheetMenuText">{value.Name}</span><span className="NoNote"></span></div></Link>
									break
								case "Browser":
									
									if (String(value.Name) !== "Summary") {
										content = <Link className="SheetMenuLink" to={{pathname: "/" + ProductName + "/" + "browser/" + datasetID + "/" + value.ID, state:  {VPDatasetID: VPDatasetID, appURL: appURL, ViewNote: value.Note[0], DetailViews: DetailViewsArray, FieldArray: FieldArray, DetailFields: DetailFields, TitleViewField: TitleViewField}}} key={value.ID}><div className={classNames} id={value.ID}><span className={iconString}></span><span className="SheetMenuText">{value.Name}</span><span className="NoNote"></span></div></Link>
									}
									break
								default:
									content = ""
									break    
								}
							}
						}
						return content
					})
				}
				{
					Object.values(this.state.ViewObjectNormal).map(function (value) {
						let iconString = ""
						if (value.hasOwnProperty("BrowserType")) {
							iconString = cn("vp-icon-16 WebIcon " + value.BrowserType[0])
						}
						else {
							iconString = cn("vp-icon-16 WebIcon " + value.Type[0])
						}
						let content = ""
						let detail1 = []
						let detail2 = []
						if (value.detailviews[0] !== ""){
							detail1 = JSON.parse(value.detailviews[0])
						}
						if (value.detailviewsuser[0] !== ""){
							detail2 = Object.values(JSON.parse(value.detailviewsuser[0]))
						}
						let DetailViewsArray = detail2
						if (typeof(detail1) === 'object'){
							if (Object.keys(detail1).length > 0){
								if (detail1.hasOwnProperty('UseDefault')){
									if (detail1.UseDefault === 0){
										DetailViewsArray = detail1.DetailFields
									}
								}
							}
						}
						//get first 3 detail views (0, 3 (non-inclusive))
						//DetailViewsArray = DetailViewsArray.filter(Boolean).slice(0,3)
						classNames = cn("SheetMenuBlock")
						if (selectedSheetID === value.ID[0]){
							classNames = cn("SheetMenuBlock selected")
						}
						if (value.status[0] !== "hidden"){
							if (value.Note[0] !== ""){
								switch (String(value.Type)) {
								case "List":
									content = <Link className="SheetMenuLink" to={{pathname: "/" + ProductName + "/" + "list/" + datasetID + "/" + value.ID, state:  {VPDatasetID: VPDatasetID, appURL: appURL, ViewNote: value.Note[0], DetailViews: DetailViewsArray, FieldArray: FieldArray, DetailFields: DetailFields, TitleViewField: TitleViewField}}} key={value.ID}><div className={classNames} id={value.ID}><span className={iconString}></span><span className="SheetMenuText">{value.Name}</span><span className="Note" title={value.Note[0]}><div className='vp-icon-16 vp-icon-note'></div></span></div></Link>
									break
								case "Matrix":
									content = <Link className="SheetMenuLink" to={{pathname: "/" + ProductName + "/" + "matrix/" + datasetID + "/" + value.ID, state:  {VPDatasetID: VPDatasetID, appURL: appURL, ViewNote: value.Note[0], DetailViews: DetailViewsArray, FieldArray: FieldArray, DetailFields: DetailFields, TitleViewField: TitleViewField}}} key={value.ID}><div className={classNames} id={value.ID}><span className={iconString}></span><span className="SheetMenuText">{value.Name}</span><span className="Note" title={value.Note[0]}><div className='vp-icon-16 vp-icon-note'></div></span></div></Link>
									break
								case "Browser":
									
									if (String(value.Name) !== "Summary") {
										content = <Link className="SheetMenuLink" to={{pathname: "/" + ProductName + "/" + "browser/" + datasetID + "/" + value.ID, state:  {VPDatasetID: VPDatasetID, appURL: appURL, ViewNote: value.Note[0], DetailViews: DetailViewsArray, FieldArray: FieldArray, DetailFields: DetailFields, TitleViewField: TitleViewField}}} key={value.ID}><div className={classNames} id={value.ID}><span className={iconString}></span><span className="SheetMenuText">{value.Name}</span><span className="Note" title={value.Note[0]}><div className='vp-icon-16 vp-icon-note'></div></span></div></Link>
									}
									break
								default:
									content = ""
									break
								}
							} else {
								switch (String(value.Type)) {
								case "List":
									
									content = <Link className="SheetMenuLink" to={{pathname: "/" + ProductName + "/" + "list/" + datasetID + "/" + value.ID, state:  {VPDatasetID: VPDatasetID, appURL: appURL, ViewNote: value.Note[0], DetailViews: DetailViewsArray, FieldArray: FieldArray, DetailFields: DetailFields, TitleViewField: TitleViewField}}} key={value.ID}><div className={classNames} id={value.ID}><span className={iconString}></span><span className="SheetMenuText">{value.Name}</span><span className="NoNote"></span></div></Link>
									break
								case "Matrix":
									
									content = <Link className="SheetMenuLink" to={{pathname: "/" + ProductName + "/" + "matrix/" + datasetID + "/" + value.ID, state:  {VPDatasetID: VPDatasetID, appURL: appURL, ViewNote: value.Note[0], DetailViews: DetailViewsArray, FieldArray: FieldArray, DetailFields: DetailFields, TitleViewField: TitleViewField}}} key={value.ID}><div className={classNames} id={value.ID}><span className={iconString}></span><span className="SheetMenuText">{value.Name}</span><span className="NoNote"></span></div></Link>
									break
								case "Browser":
									
									if (String(value.Name) !== "Summary") {
										content = <Link className="SheetMenuLink" to={{pathname: "/" + ProductName + "/" + "browser/" + datasetID + "/" + value.ID, state:  {VPDatasetID: VPDatasetID, appURL: appURL, ViewNote: value.Note[0], DetailViews: DetailViewsArray, FieldArray: FieldArray, DetailFields: DetailFields, TitleViewField: TitleViewField}}} key={value.ID}><div className={classNames} id={value.ID}><span className={iconString}></span><span className="SheetMenuText">{value.Name}</span><span className="NoNote"></span></div></Link>
									}
									break
								default:
									content = ""
									break    
								}
							}
						}
						return content
					})
				}
			</div>
		)
	}      
}